<template>
  <div class="sino-personal personal-info-box">
    <div class="sino-panel">
      <!-- 头部开始 -->
      <topPart></topPart>
      <!-- 头部结束 -->
      <!-- 中间内容开始 -->
      <div class="sino-content info-content-box">
        <div class="content-card">
          <uploadImg :userInfo="userInfo" @changeFileKey="changeFileKey"></uploadImg>
          <div class="card-item">
            <div class="item item-label">真实姓名</div>
            <div class="item item-value">{{userInfo.name}}</div>
          </div>
          <div class="card-item">
            <div class="item item-label">所在工会</div>
            <div class="item item-value van-multi-ellipsis--l2">{{userInfo.unionName}}</div>
          </div>
          <div class="card-item">
            <div class="item item-label">所在科室</div>
            <div class="item item-value">{{userInfo.deptName}}</div>
          </div>
          <div class="card-item">
            <div class="item item-label">身份证号</div>
            <div class="item item-value">{{userInfo.idCard}}</div>
          </div>
          <div class="card-item">
            <div class="item item-label">会员状态</div>
            <div class="item item-value">{{userInfo.status}}</div>
          </div>
          <div class="card-item">
            <div class="item item-label">会员编制</div>
            <div class="item item-value">{{userInfo.authorizedStrength == 0?'正式职工':'派遣职工'}}</div>
          </div>
          <div class="card-item">
            <div class="item item-label">会员身份</div>
            <div class="item item-value">{{userInfo.identity}}</div>
          </div>
          <div class="card-item">
            <div class="item item-label">会员代表</div>
            <div class="item item-value">{{userInfo.memberRepre == '1'?'是':'否'}}</div>
          </div>
          <div class="card-item">
            <div class="item item-label">职工代表</div>
            <div class="item item-value">{{userInfo.representative == '1'?'是':'否'}}</div>
          </div>

          <!-- 动态属性开始 -->

          <div class="card-item" v-for="(item,index) in trendParamAttr" :key="index">
            <div class="item item-label">{{item.name}}</div>
            <div class="item item-value">{{item.cks}}</div>
          </div>

          <!-- 动态属性结束 -->

          <div class="card-item" v-if="userInfo.nation">
            <div class="item item-label">民族</div>
            <div class="item item-value">{{userInfo.nation}}</div>
          </div>
          <div class="card-item" v-if="userInfo.post">
            <div class="item item-label">岗位</div>
            <div class="item item-value">{{userInfo.post}}</div>
            <!-- <div class="item item-value">{{postAttr}}</div> -->
          </div>
          <div class="card-item" v-if="userInfo.jobTitle">
            <div class="item item-label">职称</div>
            <div class="item item-value">{{userInfo.jobTitle}}</div>
          </div>
          <div class="card-item" v-if="userInfo.phone">
            <div class="item item-label">联系电话</div>
            <div class="item item-value">{{userInfo.phone}}</div>
            <!-- <div class="item item-value">
              <cube-input v-model="userInfo.phone"></cube-input>
            </div>-->
          </div>
        </div>
      </div>
      <!-- 中间内容结束 -->
      <div class="sino-footer">
        <cube-button @click="save">保存</cube-button>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import topPart from "../../components/topPart";
import uploadImg from "./components/UploadImg";
export default {
  components: {
    topPart,
    uploadImg
  },
  data() {
    return {
      userInfo: {},
      past: "",
      phone: sessionStorage.phone,
      // paramAttr: ["post", "jobTitle", "status", "staffIdentity"], //需要转换value的配置数组
      paramAttr: [
        //需要转换value的配置数组
        {
          key: "staffStatus", //会员状态
          value: "status"
        },
        {
          key: "staffIdentity", //会员身份
          value: "identity"
        }
      ],
      defineParamAttr: [
        //pc可修改的人员字典属性获取
        {
          //职称
          key: "post", //需要传给后端的字串
          value: "post" //需要在页面展示的字段
        },
        {
          key: "jobTitle", //岗位
          value: "jobTitle"
        }
      ],
      trendParamAttr: [],
      filekey: "" //从子组件接收的fileKey
    };
  },
  created() {
    this.init();
    this.userInfo = JSON.parse(localStorage.getItem("detailInfo"));

    console.log(this.userInfo);
  },
  methods: {
    // 获得子组件的传过来的fileKey
    changeFileKey(filekey) {
      this.filekey = filekey;
    },
    // 更换头像函数
    openPhote() {},
    transfromDate(item) {
      var trendFlag = this.userInfo[item.fieldp]; //人员标志位
      return trendFlag;
    },
    init() {
      this.eachDate(this.paramAttr, "getDictValue");
      this.eachDate(this.defineParamAttr, "getUserDictValue");
      this.gainTrendParams();
    },
    save() {
      this.changeInfo(this.filekey);

      // let phoneReg = new RegExp(/^[1][3,4,5,7,8][0-9]{9}$/);
      // let phoneReg = new RegExp(/^1\d{10}$/);
      // console.lgo("需要调后端接口保存手机号");
      // if (!phoneReg.test(this.userInfo.phone)) {
      //   toast(this, "请输入正确手机号", "error");
      // } else {
      //   // TODO 修改手机号
      //   this.$router.go(-1);
      // }
    },
    // 调用修改保存信息接口
    changeInfo(filekey) {
      var obj = { filekey: filekey };
      this.centralControl.axios.centralControl(
        "updateStaffPhotoAPP",
        res => {
          const { data = {}, code, message } = res;
          if (code == "200") {
            toast(this, "保存成功");
            setTimeout(() => {
              this.$router.push("personalCenter");
            }, 1000);
          } else {
            toast(this, res.message, "error");
          }
        },
        obj
      );
    },
    //循环配置数组
    eachDate(attr, hrefUrl) {
      for (let val in attr) {
        this.getDictionaryValue(attr[val], hrefUrl);
      }
    },
    // 获取人员字典属性
    getDictionaryValue(type, urlHref) {
      this.centralControl.axios.centralControl(
        urlHref,
        res => {
          if (res.code == 200) {
            this.gainDate(res.data, type);
            console.log(res.data);
          } else {
            toast(this, res.message, "error");
          }
        },
        {
          dictType: type.key
        }
      );
    },
    // 获取动态属性
    gainTrendParams() {
      this.centralControl.axios.centralControl(
        "getListDate",
        res => {
          if (res.code == 200) {
            this.paramAttrs(res.data);
            //this.trendParamAttr = res.data;
          } else {
            toast(this, res.message, "error");
          }
        },
        {}
      );
    },
    // 判断动态属性是否为空
    paramAttrs(data) {
      var arr = [];
      for (let i in data) {
        var str = this.transfromDate(data[i]);
        if (str != "") {
          data[i].cks = str;
          arr.push(data[i]);
        }
      }
      this.trendParamAttr = arr;
    },
    // 获取动态属性的值
    // gainTrendDate() {
    //   this.centralControl.axios.centralControl(
    //     "getFieldValue",
    //     res => {
    //       if (res.code == 200) {
    //         console.log(res.data);
    //       } else {
    //         toast(this, res.message, "error");
    //       }
    //     },
    //     {
    //       fieldp: "field1"
    //     }
    //   );
    // },
    // 根据数据匹配数据
    gainDate(attr, infoName) {
      attr.forEach((a, b) => {
        if (this.userInfo[infoName.value]) {
          if (a.dictValue == this.userInfo[infoName.value]) {
            this.$set(this.userInfo, infoName.value, a.dictLabel);
          }
        }
      });
    },
    //根据后端返回的数据找出动态字段的值
    findDate() {
      this.trendAttr;
      this.userInfo;
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/theme.styl';
@import '../../assets/stylus/common.styl';

.personal-info-box {
  .van-uploader {
    width: 100%;
  }

  .van-uploader__input-wrapper {
    width: 100%;
  }

  .van-cell {
    border-bottom: 0.026667rem solid #f0f0f4;
    align-items: center;
  }

  .header-box {
    display: flex;
  }

  .header-img {
    width: 40px;
    height: 40px;
    border-radius: 50px;
    margin-left: 15px;
  }
}

.info-content-box {
  myContent();
  bottom: 74px;
}

.sino-personal {
  .hiddenTwo {
    overflow: hidden !important;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    margin: auto;
  }

  .cube-input::after {
    border: none;
  }

  .sino-panel {
    width: 100%;
    padding-bottom: 66px;

    .content-card {
      background: rgba(255, 255, 255, 1);
      font-size: 14px !important;
      color: rgba(53, 53, 53, 1);

      .card-item {
        height: 50px;
        display: flex;
        border-bottom: 1px solid #F0F0F4;

        .cube-input-field {
          border: 1px solid #e5e5e5;
          color: #333;
          text-align: left !important;
        }

        .item {
          flex: 1;
          display: flex;
          align-items: center;
        }

        .item-label {
          padding-left: 0.4rem;
        }

        .item-value {
          justify-content: flex-end;
          text-align: right;
          padding-right: 0.4rem;
          opacity: 0.6;

          .cube-input-field {
            text-align: right;
          }
        }
      }
    }
  }

  .sino-footer {
    width: 100%;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    position: fixed;
    bottom: 0;

    .cube-btn {
      width: 90%;
      border-radius: 0.16rem;
      margin: 0 auto;
    }
  }
}
</style>